import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { isMobileOnly } from "react-device-detect";
import RightArrow from "../../assets/SVGComponents/RightArrow";
import LeftArrow from "../../assets/SVGComponents/LeftArrow";
import { StyledArrowWrapper } from "./StyledComponents";

const Swiper = ({ slides, configuration, couponsPerPage, sliderType, bannerRowAutoplay }) => {
    const {
        autoplay,
        autoplay_milliseconds,
        include_navigation,
        include_pagination_bar,
        infinite_loop,
        navigation_color,
        pagination_color,
        padding,
        outter_margin,
        space_between_slides,
        background_color,
    } = configuration;
    const [paginationWidth, setPaginationWidth] = useState(
        100 / slides.length + "%"
    );
    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <StyledArrowWrapper
                className="slick-arrow"
                id="FODSwiperCustomRightArrow"
                style={{
                    right: "0",
                    color: navigation_color ?? "white",
                    margin:
                        sliderType !== "coupon"
                            ? null
                            : space_between_slides
                            ? "0 " + space_between_slides
                            : "0 10px",
                }}
                onClick={onClick}
            >
                <RightArrow fill={navigation_color ?? null} />
            </StyledArrowWrapper>
        );
    };

    const PrevArrow = (props) => {
        const { onClick } = props;
        return (
            <StyledArrowWrapper
                className="slick-arrow"
                id="FODSwiperCustomLeftArrow"
                style={{
                    left: "0",
                    color: navigation_color ?? "white",
                    margin:
                        sliderType !== "coupon"
                            ? null
                            : space_between_slides
                            ? "0 " + space_between_slides
                            : "0 10px",
                }}
                onClick={onClick}
            >
                <LeftArrow fill={navigation_color ?? null} />
            </StyledArrowWrapper>
        );
    };

    const CustomPagination = () => {
        return (
            <div
                className="FODSwiperCustomPagination"
                style={{
                    width: paginationWidth,
                    height: "5px",
                    background: pagination_color ?? "black",
                    display: "block",
                    transition: "width 2s ease-in-out",
                }}
            />
        );
    };
    const swiperSettings = {
        arrows: include_navigation && slides.length > 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        afterChange: (idx) =>
            setPaginationWidth((100 / slides.length) * (idx + 1) + "%"),
        infinite: infinite_loop && slides.length > 1,
        slidesToShow:
            slides.length < couponsPerPage ? slides.length : couponsPerPage,
        autoplaySpeed: bannerRowAutoplay
            ? bannerRowAutoplay
            : autoplay_milliseconds,
        draggable: isMobileOnly,
        autoplay,
    };

    const sliderWrapperStyles = {
        padding: padding,
        margin: outter_margin,
        background: background_color,
        overflowX: "hidden",
    };

    return (
        <div className="FODSwiperContainer" style={sliderWrapperStyles}>
            {include_pagination_bar &&
            ((sliderType !== "coupon" && slides.length > 1) ||
                slides.length > 3) ? (
                <CustomPagination />
            ) : null}
            <Slider
                key={`fod-${sliderType}-slider`}
                {...swiperSettings}
                style={{
                    margin:
                        sliderType !== "coupon"
                            ? null
                            : space_between_slides
                            ? "0 -" + space_between_slides
                            : "0 -10px",
                }}
            >
                {slides}
            </Slider>
        </div>
    );
};

export default Swiper;
